module.exports = __webpack_public_path__ + "static/08-puffins-f5ed4d247f663f2c676ba61ede0b5789.jpg";